import React from 'react';
import PageLayout from '../../ui/PageLayout';
import PageHeader from '../../ui/PageHeader';

export default function AdventureWorldLayout({ children }) {
  return (
    <PageLayout
      header={<PageHeader title="Mudo Adventure" />}
    >
      {children}
    </PageLayout>
  );
}